module.exports = __webpack_public_path__ + "media/flags/sy-6aaab03b.svg";